<template>
    <div class="page">
        <div class="top">
            <div class="t1">尊敬的{{ simInfo.vipLever }}星用户，{{ simInfo.dayTime }}</div>
            <div class="t2">
                <div class="tel">{{ recordLoginText }}</div>
                <div class="adress">{{ simInfo.city }}</div>
            </div>
            <div class="v-q-y">
                <div class="v-l">星级专属权益</div>
                <div class="v-r" @click="toRecharge()">升级权益 >></div>
            </div>
            <div class="h-swiper">
                <van-swipe :loop="false" :width="100" :show-indicators="false">
                    <van-swipe-item>
                        <div class="swiper-i">
                            <div class="icon">
                                <img src="@/assets/new/50_2.png" alt="">
                            </div>
                            <div class="name">专属优惠商城</div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="swiper-i">
                            <div class="icon">
                                <img src="@/assets/new/52_2.png" alt="">
                            </div>
                            <div class="name">独享上网频段</div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="swiper-i">
                            <div class="icon">
                                <img src="@/assets/new/54_2.png" alt="">
                            </div>
                            <img src="@/assets/new/66.png" alt="" class="lock">
                            <div class="name">网络提高300%</div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="swiper-i">
                            <div class="icon">
                                <img src="@/assets/new/82_2.png" alt="">
                            </div>
                            <img src="@/assets/new/66.png" alt="" class="lock">
                            <div class="name">信号加强300%</div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="swiper-i">
                            <div class="icon">
                                <img src="@/assets/new/kefu_2.png" alt="">
                            </div>
                            <img src="@/assets/new/66.png" alt="" class="lock">
                            <div class="name">星级专属客服</div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>

        <div class="v-tabs">
            <div class="tabs" @click="tabsChange('1')" :class="[index === '1' ? 'tabs-active' : '']">卡板详情</div>
            <div class="tabs" @click="tabsChange('2')" :class="[index === '2' ? 'tabs-active' : '']">套餐流量</div>
            <div class="tabs" @click="tabsChange('3')" :class="[index === '3' ? 'tabs-active' : '']">WIFI管理</div>
        </div>

        <!--  <div class="v-tabs1 v-tabs">
            <div class="tabs" @click="tabsChange('1')" :class="[index==='1' ? 'tabs-active' : '']">卡板详情</div>
            <div class="tabs" @click="tabsChange('2')" :class="[index==='2' ? 'tabs-active' : '']">套餐流量</div>
        </div> -->

        <div class="tabs-c" :style="{ 'height': index === '3' ? '305px' : '' }">
            <template v-if="index === '1'">
                <div class="tabs-top">
                    <div class="k-stutas">卡板状态<span>{{ simInfo.cardStateName }}</span></div>
                    <div class="k-stutas1">
                        <img src="@/assets/new/63_2.png" alt="">
                        {{ isAuthName }}
                    </div>
                </div>
                <div class="liu">
                    <div class="l">
                        <div class="num">{{ money_format(userAccount.amount / 100, 2, ".", ",") * 1 }}</div>
                        <div class="n-l">账号余额</div>
                    </div>
                    <div class="xian" />
                    <div class="l">
                        <div class="num" v-if="simInfo.isNoLimitData == 1">无限量</div>
                        <div class="num" v-else>{{ fluxMtoG(simInfo.surplusFlowRate || 0) }} GB</div>
                        <div class="n-l">剩余通用流量</div>
                    </div>
                    <div class="xian" />
                    <div class="l">
                        <div class="num">{{ simInfo.remainDay }}</div>
                        <div class="n-l">到期天数</div>
                    </div>
                </div>
                <div class="btn">
                    <div class="b1" @click="toRecharge()">
                        <img src="@/assets/new/64_2.png" alt="">
                        充套餐
                    </div>
                    <div class="b2" @click="toBalanceRecharge()" v-if="showYu==true">
                        <img src="@/assets/new/65.png" alt="">
                        充余额
                    </div>
                    <div class="b2" @click="toLog()" v-else>
                        <img src="@/assets/new/65.png" alt="">
                        查记录
                    </div>
                </div>
            </template>

            <template v-if="index === '2'">
                <div class="tabs-top">
                    <div class="k-stutas">{{ simInfo.pkgName }}</div>
                    <div class="k-stutas1">有效期：{{ simInfo.endTimeString }}</div>
                </div>
                <div class="progress">
                    <van-progress :percentage="((simInfo.flowRate - simInfo.surplusFlowRate) / simInfo.flowRate) * 100"
                        stroke-width="8px" :show-pivot="false" pivot-color="#487FE8"
                        color="linear-gradient(to right, #56B2E7, #487FE8)" />
                </div>
                <div class="liu">
                    <div class="l">
                        <div class="num" v-if="simInfo.isNoLimitData == 1">无限量</div>
                        <div class="num" v-else>{{ fluxMtoG(simInfo.flowRate || 0) }}G</div>
                        <div class="n-l">总流量</div>
                    </div>
                    <div class="l">
                        <div class="num" v-if="simInfo.isNoLimitData == 1">无限量</div>
                        <div class="num" v-else>{{ fluxMtoG(simInfo.flowRate - simInfo.surplusFlowRate || 0) }}G</div>
                        <div class="n-l">已用流量</div>
                    </div>
                    <div class="l">
                        <div class="num" v-if="simInfo.isNoLimitData == 1">无限量</div>
                        <div class="num" v-else>{{ fluxMtoG(simInfo.surplusFlowRate || 0) }}G</div>
                        <div class="n-l">剩余流量</div>
                    </div>
                </div>
                <div class="btn" style="padding-top:22px;">
                    <div class="b1" @click="toRecharge()">
                        <img src="@/assets/new/64_2.png" alt="">
                        充套餐
                    </div>
                    <div class="b2" @click="toBalanceRecharge()" v-if="showYu==true">
                        <img src="@/assets/new/65.png" alt="">
                        充余额
                    </div>
                    <div class="b2" @click="toLog()" v-else>
                        <img src="@/assets/new/65.png" alt="">
                        查记录
                    </div>
                </div>
            </template>

            <template v-if="index === '3'">
                <div class="tabs-top" style="padding:11px 13px 8px;">
                    <div class="k-stutas">修改密码</div>
                    <div class="confirm" @click="toUpdateWifi">确认修改</div>
                </div>
                <van-field v-model="wifiName" placeholder="请输入热点名称" />
                <van-field v-model="wifiPass" placeholder="请输入wifi密码" />
                <div class="tabs-top" style="padding:0 13px;">
                    <div class="k-stutas">切换网络</div>
                </div>
                <!-- <div class="btn2" style="padding-top:12px;">
                    <div class="b1" @click="bChange('1')" :class="[inx === '1' ? 'b-active' : '']">
                        <img src="@/assets/new/70.png" alt="">
                        中国电信
                    </div>
                    <div class="b1" @click="bChange('2')" :class="[inx === '2' ? 'b-active' : '']">
                        <img src="@/assets/new/71.png" alt="">
                        中国联通
                    </div>
                    <div class="b1" @click="bChange('0')" :class="[inx === '0' ? 'b-active' : '']">
                        <img src="@/assets/new/68.png" alt="">
                        中国移动
                    </div>
                </div> -->
                <div class="btn2 btn22" style="padding-top:12px;">
                    <div class="b1" @click="bChange('1')" :class="[inx === '1' ? 'b-active' : '']">
                        <img src="@/assets/new/70.png" alt="">
                        中国电信
                    </div>
                    <div class="b1" @click="bChange('2')" :class="[inx === '2' ? 'b-active' : '']">
                        <img src="@/assets/new/71.png" alt="">
                        中国联通
                    </div>
                </div>

                <div class="quantity">
                    <div class="v-l">
                        <div class="l-icon">
                            <img src="@/assets/home/0.png" alt="" v-if="battery * 1 === 0">
                            <img src="@/assets/home/1.png" alt="" v-if="battery * 1 > 0 && battery * 1 < 26">
                            <img src="@/assets/home/2.png" alt="" v-if="battery * 1 > 25 && battery * 1 < 51">
                            <img src="@/assets/home/4.png" alt="" v-if="battery * 1 > 50 && battery * 1 < 100">
                            <img src="@/assets/home/4.png" alt="" v-if="battery * 1 === 100">

                        </div>
                        <div class="l-name">电量</div>
                        <div class="l-num">{{ battery }}%</div>
                    </div>
                    <div class="v-l">
                        <div class="l-icon">
                            <img src="@/assets/home/5.png" alt="">
                        </div>
                        <div class="l-name">热点链接</div>
                        <div class="l-num">{{ deviceConnNum }}设备</div>
                    </div>
                </div>
                <div class="status" :class="[deviceStatus === '1' ? 'status1' : 'status2']">{{ deviceStatus === '0' ?
                    '设备离线' : "设备在线" }}</div>
            </template>
        </div>

        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item @click="toKefu()">
                <img src="@/assets/new/62_2.png" alt="">
            </van-swipe-item>
            <van-swipe-item @click="buyCard()">
                <img src="@/assets/new/51.png" alt="">
            </van-swipe-item>
        </van-swipe>

        <div class="box">尊享权益</div>

        <div class="h5-more-fl">
            <div class="fl-item" @click="toRecharge()">
                <img src="@/assets/new/101.png" alt="">
                <div>套餐订购</div>
            </div>
            <div class="fl-item" @click="toBalanceRecharge" v-show="showYu">
                <img src="@/assets/new/102.png" alt="">
                <div>余额充值</div>
            </div>
            <div class="fl-item" @click="toSupplierAuth">
                <img src="@/assets/new/103.png" alt="">
                <div>实名认证</div>
            </div>
            <div class="fl-item" @click="autoPkg">
                <img src="@/assets/new/104.png" alt="">
                <div>自动续费</div>
            </div>
            <div class="fl-item" @click="toActive">
                <img src="@/assets/new/106.png" alt="">
                <div>一键复机</div>
            </div>
            <div class="fl-item" @click="buyCard">
                <img src="@/assets/new/107.png" alt="">
                <div>在线商城</div>
            </div>
            <div class="fl-item" @click="toLog">
                <img src="@/assets/new/108.png" alt="">
                <div>充值记录</div>
            </div>
            <!-- <div class="fl-item" @click="toSelectMa">
                <img src="@/assets/new/58.png" alt="">
                <div>充值码</div>
            </div> -->
            <div class="fl-item" @click="outLogin">
                <img src="@/assets/new/icon48.png" alt="">
                <div>退出登录</div>
            </div>
        </div>

        <div class="footer">
            <div class="foot-n">
                <div class="znzd">智能诊断</div>
                <div class="small">系统智能诊断，无需排队</div>
            </div>
            <div class="f-btn" @click="gotoView">去诊断</div>
        </div>




        <van-dialog v-model="appshowimg" title="保存充值码" confirmButtonColor="#86de6b" confirmButtonText="知道了">
            <div style="font-size: 18px;padding-top:6px;text-align: center;font-weight: bold;">卡号 {{ simInfo.virtualNo }}
            </div>
            <img style="width: 100%" :src="imgUrl" />
            <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">截图保存二维码,后期可直接扫码充值</div>
        </van-dialog>


        <van-dialog v-model="isShowAuth" title="实名认证提示" :show-confirm-button="false">
            <div class="dialog-text">
                根据国家规定，手机卡需要进行实名认证，实名认证后方可使用。
            </div>
            <div class="dialog-text">
                如果您已操作实名认证，无需重复操作，重启手机后即可畅享网络。
            </div>
            <div class="btn-vis">
                <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
                <van-button type="primary" class="dialog-btn3" @click="toSupplierAuth">立即实名</van-button>
            </div>
        </van-dialog>


        <van-dialog v-model="isChangeCard" title="换卡通知" :show-confirm-button="false">
            <div class="dialog-text">
                由于运营商系统故障，此卡已暂停使用，我司将给您更换网速更好的新卡使用。<br />
                旧卡套餐和余额 会自动转移新卡上。感谢您的理解和支持。
            </div>
            <div class="btn-vis">
                <van-button type="primary" class="dialog-btn2" @click="cancelChange">取消</van-button>
                <van-button type="primary" class="dialog-btn3" @click="toChangeCard">去换新卡</van-button>
            </div>
        </van-dialog>



        <van-dialog v-model="showQie" title="切换提示" @confirm="confirmQie" @cancel="showQie == false" show-cancel-button
            confirmButtonText="确定切换" cancelButtonText="取消切换" confirmButtonColor="#333" cancelButtonColor="#9e9e9e">
            <div class="el-tip">
                <div>1.切换网络前需要先实名切换的卡板，否则将会导致停机</div>
                <div>2.切换成功后，设备将会在10分钟后完成切换，请耐心等待</div>
                <div>3.信号灯绿色常亮表示切换完毕，如有其它疑问，可联系客服处理</div>
                <div>4.切换成功之后，如长时间无法链接网络。请在主页面点击一件诊断</div>
                <!-- <van-checkbox v-model="checked" shape="square">这张卡网速太慢，我要换卡使用</van-checkbox> -->
            </div>
        </van-dialog>



    </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
    data() {
        return {
            showYu: localStorage.getItem("showYu") == 0 ? true : false,

            showQie: false,
            showQieInx: '',
            dataForm: {

            },
            battery: 0, //电量
            deviceConnNum: 0, //链接人数
            deviceStatus: '', // 0离线 1 在线

            index: '1',
            inx: '1',
            wifiName: '',
            wifiPass: '',
            notifyContent: "上网卡不能更换卡槽，否则将会导致无法使用。如有疑问 请联系在线客服处理",
            showLoadTitle: localStorage.getItem("isShowApp") == 1 ? true : false,
            isShowLoad: localStorage.getItem("isShowApp"),
            newHomeImg: localStorage.getItem("newHomeImg"),
            newHomeUrl: localStorage.getItem("newHomeUrl"),
            isAuth: localStorage.getItem("isAuth"),
            isAgentLogin: localStorage.getItem("isAgentLogin"),
            yucun: localStorage.getItem("yucun"),
            isSale: localStorage.getItem("isSale"),
            shebeiLogin: localStorage.getItem("shebeiLogin"),
            ishavePkg: localStorage.getItem("ishavePkg"),
            ishavePrice: localStorage.getItem("ishavePrice"),
            kefuUrl: localStorage.getItem("kefuUrl"),
            isChangeCard: false,
            isAuthName: '未实名/未知', //实名状态
            isShowAuth: false,
            appshowimg: false,
            canChangeCard: false,
            userAccount: {},
            simInfo: {},
            show: false,
            reacheShow: false,
            reacheShows: false,
            isShow: true,
            iccid: localStorage.getItem('iccid'),
            recordLoginText: localStorage.getItem('recordLoginText'),
            isNewPage: localStorage.getItem('isNewPage'),
            alreadyHasAccount: false,
            ctccAuthShow: false,
            cmccXxtx: false,
            cuccAuthShow: false,
            cmccAuthShow: false,
            otherAuth: false,
            otherUrl: '',
            isShowPrice: false,
            isShowDiejiaQuan: false,
            isShowYueHuodong: false,
            appshowimg: false,
            imgUrl: '',
            ctcc5GAuth: false,
            ctccJieAuth: false,
            guangdianAuth: false, 
            isDialogShow: false,
            phoneList: [],
            dialogIccid: "",
        }
    },
    async created() {
        // localStorage.setItem("iccid", "8888888888888877777777");
        // localStorage.setItem('recordLoginText','8888888888888877777777');
        // this.$store.state.iccid = "8888888888888877777777";

        await this.getUserSimInfo();
        await wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: localStorage.getItem("intoNo") }, "post").then((res) => {
            if (res.data.code == 200) {
                this.isAuthName = "已实名";
            } else if (res.data.code == 302) {
                this.isAuthName = "请先购买套餐";
            }
            sessionStorage.setItem("alreadyCertification", "true");
        });
        await this.getAccount();
        /**   换卡判断       **/
        let fd = new FormData();
        fd.append("iccid", localStorage.getItem("iccid"));
        await wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
            if (res.data.code == "200") { //换卡提醒
                this.isChangeCard = true;
                localStorage.setItem('isTochangeCard', 1)
            } else if (
                this.isSale > 0 &&
                this.ishavePkg == 0 &&
                this.ishavePrice == 1 &&
                this.isAuthName == '请先购买套餐'
            ) {
                this.isShowPrice = true;
            } else if (this.isAuthName == '未实名/未知') {
                this.isShowAuth = true;
            } else if (this.yucun == 1) {
                this.isShowYueHuodong = true;
            } else if (this.yucun == 3) {
                this.isShowDiejiaQuan = true;
            }
        });
    },
    methods: {
        tabsChange(i) {
            if (i == 3) {
                i = 1;
                this.index = i;
                window.location.href = this.simInfo.sheUrl
                return;
            }
            this.index = i;
            // if (i == 3) {
            //     if (this.simInfo.sheUrl && this.simInfo.sheUrl == '设备接口') {
            //         var data = {
            //             iccid: localStorage.getItem("iccid")
            //         }
            //         wxRequest("sim/get/shebei/info", data, "post").then(res => {
            //             if (res.data.code === '200') {
            //                 this.dataForm = res.data.data
            //                 this.inx = String(res.data.data.netState)
            //                 this.battery = res.data.data.sysMap.battery;
            //                 this.wifiName = res.data.data.wifiName;
            //                 this.wifiPass = res.data.data.wifiPwd;
            //                 this.deviceConnNum = res.data.data.deviceConnNum;
            //                 this.deviceStatus = res.data.data.deviceStatus;
            //             } else {
            //                 Dialog.alert({
            //                     title: '温馨提示',
            //                     message: res.data.message
            //                 })
            //             }
            //         })
            //     } else if (this.simInfo.sheUrl && this.simInfo.sheUrl.length > 5) {
            //         Dialog.confirm({
            //             message: "请勿随意操作切换网络，操作切换网络之后 请联系客服处理，否则将导致设备无法正常使用。 ",
            //             confirmButtonText: "已知晓",
            //             cancelButtonText: "取消",
            //         }).then(() => {
            //             window.location.href = this.simInfo.sheUrl+this.simInfo.iccid;

            //         }).catch(() => { });

            //     }
            //     else {
            //         Dialog.alert({
            //             title: '温馨提示',
            //             message: 'WIFI功能即将上线，尽请期待！'
            //         })
            //         return;
            //     }
            // }
            // this.index = i

        },

        bChange(i) {
            if (this.inx == i) {
                return;
            }
            if (i === '1') {
                if (this.dataForm.sysMap.in1AuthName == '未实名') {
                    Dialog.confirm({
                        message: "尊敬的用户你好，请先完成实名认证后 再进行切卡操作。如已完成实名认证 请稍后等待5分钟再试。",
                        confirmButtonText: "去实名",
                        cancelButtonText: "取消",
                    }).then(() => {
                        wxRequest("wxAuth/ctcc/to/5G/auth", { iccid: this.dataForm.sysMap.inIccid1, isCheckout: "sa" }, "post").then((res) => {
                            if (res.data.code == "200") {
                                window.location.href = res.data.data;
                            } else {
                                Dialog.alert({
                                    title: "提示",
                                    message: res.data.message,
                                });
                            }
                        });
                    }).catch(() => { });
                    return;
                }
            } else if (i === '2') {
                if (this.dataForm.sysMap.in2AuthName == '未实名') {
                    Dialog.confirm({
                        message: "尊敬的用户你好，请先完成实名认证后 再进行切卡操作。如已完成实名认证 请稍后等待5分钟再试。",
                        confirmButtonText: "去实名",
                        cancelButtonText: "取消",
                    }).then(() => {
                        window.location.href = 'http://wx.yunzhineng.top/#/user/cuccAuthUrl?iccid=' + this.dataForm.sysMap.inIccid2;
                    }).catch(() => { });
                    return;
                }
            }
            //  Dialog.alert({ title: "温馨提示", message: '功能即将上线，请后续关注公众号通知' });
            // this.inx = i
            this.showQieInx = i;
            this.showQie = true;
        },
        confirmQie() {
            var data = {
                iccid: localStorage.getItem("iccid")
            }
            if (this.showQieInx == 1) {
                data.cardSlot = this.dataForm.sysMap.in1Num
                data.newIccid = this.dataForm.sysMap.inIccid1
            } else if (this.showQieInx == 2) {
                data.cardSlot = this.dataForm.sysMap.in2Num
                data.newIccid = this.dataForm.sysMap.inIccid2
            }
            wxRequest("sim/update/shebei/qie", data, "post").then(res => {
                if (res.data.code === '200') {
                    this.inx = this.showQieInx;
                    this.showQie = false;
                    Dialog.alert({
                        title: '切换成功',
                        message: res.data.message
                    })
                    localStorage.setItem("iccid", data.newIccid);
                    this.$store.state.iccid = data.newIccid;
                    //this.$router.push({ path: '/userNew/logins', query: {  } })
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        toUpdateWifi() {
            var data = {
                wifiName: this.wifiName,
                wifiPwd: this.wifiPass,
                iccid: localStorage.getItem("iccid")
            }
            wxRequest("sim/update/shebei/pwd", data, "post").then(res => {
                if (res.data.code === '200') {
                    Dialog.alert({
                        title: '修改成功',
                        message: res.data.message
                    })
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
            //Dialog.alert({ title: "温馨提示", message: '功能即将上线，请后续关注公众号通知' });
        },

        toKefu() {
            wxRequest("sim/kefu/url", { iccid: this.$store.state.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: res.data.message
                    });
                }
            })
        },

        outLogin() {
            localStorage.removeItem('iccid');
            localStorage.removeItem('userPhone');
            // localStorage.removeItem('recordLoginText');
            window.location.href = 'http://wx.yunzhineng.top/#/user/';
        },

        selectIon(item, index) {
            this.inx = index
            this.dialogIccid = item.cardNo
        },
        sureToChange() {
            console.log(this.dialogIccid)
            let data = {
                requestId: this.dialogIccid,
                code: "1"
            };
            let recordLoginText = this.dialogIccid;
            wxRequest("sim/bind", data, "get").then((res) => {
                if (res.data.code == 200) {
                    this.isDialogShow = false
                    let record = res.data.data;
                    let iccid = record.iccid;
                    if (record.titleMap) {
                        localStorage.setItem("wxTitle", record.titleMap.title);
                        localStorage.setItem("wxText", record.titleMap.context);
                        localStorage.setItem("wxUrls", record.titleMap.urls);
                    } else {
                        localStorage.setItem("wxTitle", '');
                        localStorage.setItem("wxText", '');
                        localStorage.setItem("wxUrls", '');
                    }
                    localStorage.setItem('isNewPage', record.isNewPage);
                    this.$store.state.isNewPage = record.isNewPage;
                    localStorage.setItem('newHomeImg', record.newHomeImg);
                    localStorage.setItem('newHomeImg2', record.newHomeImg2);
                    localStorage.setItem('newHomeUrl', record.newHomeUrl);
                    localStorage.setItem("mobile", record.mobile);
                    localStorage.setItem("isBindPhone", record.isBindPhone);
                    localStorage.setItem("supplierTypeName", record.supplierTypeName);
                    localStorage.setItem("wxHeadImg", record.wxHeadImg);
                    localStorage.setItem("wxNickName", record.wxNickName);
                    localStorage.setItem("recordLoginText", recordLoginText);
                    localStorage.setItem("supplierName", record.supplierName);
                    localStorage.setItem("iccid", iccid);
                    localStorage.setItem("intoNo", record.intoNo);
                    localStorage.setItem("phoneNo", record.userPhone);
                    localStorage.setItem("userPhone", record.userPhone);
                    localStorage.setItem("openId", record.openId);
                    localStorage.setItem("agentId", record.agentId);
                    localStorage.setItem("flowRatePool", record.flowRatePool);
                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;
                    this.$store.state.iccid = iccid;
                    this.$store.state.flowRatePool = res.data.data.flowRatePool;
                    this.$store.state.intoNo = record.intoNo;
                    if (record.isToYuCun != 1) {
                        this.$router.replace("/user/openPrice");
                    } else {
                        this.$router.replace('/new/home');
                    }
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            });

        },
        toChangeSim() {
            wxRequest("she/select/changeList", { iccid: localStorage.getItem("iccid") }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.phoneList = res.data.data;
                    this.isDialogShow = true;
                } else {
                    Dialog.alert({
                        message: res.data.message,
                    });
                }
            });
        },
        gotoView() {
            this.$router.push({
                path: '/user/diagnosis'
            })
        },
        cancelChange() {
            this.isShowYueHuodong = false,
                this.isShowAuth = false;
            this.isChangeCard = false;
            this.isShowPrice = false;
            this.isShowDiejiaQuan = false;
        },
        toChangeCard() {
            this.$router.push({
                name: "userChgCard",
                query: {
                    oldIccid: localStorage.getItem("iccid")
                },
            });
        },
        toLog() {
            this.$router.push({
                path: "/user/balanceRechargeRecord",
                query: {
                    iccid: this.$store.state.iccid,
                },
            });
        },
        buyCard() {
            wxRequest("applyChangeSim/select/agent/buy/power", { oldIccid: localStorage.getItem("iccid") }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.$router.push("/user/liuliangka?agentId=" + this.simInfo.agentId);
                } else {
                    Dialog.alert({
                        message: res.data.message,
                    });
                }
            });
        },
        toActive() {
            wxRequest("sim/to/active", { iccid: localStorage.getItem('iccid') }, 'get').then(res => {
                Dialog.alert({ message: res.data.message })
            })
        },
        toSelectMa() {
            wxRequest("sim/get/invent/ma", { iccid: this.$store.state.iccid }, "post").then(res => {
                if (res.data.code == '200') {
                    if (res.data.data) {
                        this.imgUrl = res.data.data;
                        this.appshowimg = true;
                    }
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    });
                }
            })
        },
        autoPkg() {
            this.$router.push({ path: '/user/renew', query: { iccid: this.$store.state.iccid } })
        },
        getUserSimInfo() {
            wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(
                (res) => {
                    if (res.data.code == 200) {
                        let result = res.data.data;
                        if (result.flowRatePool == "电信") {
                            this.ctccAuthShow = true;
                        } else if (result.flowRatePool == "电信接口") {
                            this.ctccJieAuth = true;
                        } else if (result.flowRatePool == "5G电信") {
                            this.ctcc5GAuth = true;
                        } else if (result.flowRatePool == "联通") {
                            this.cuccAuthShow = true;
                        } else if (result.flowRatePool == "前海") {
                            this.qianhaiSHow = true;
                        } else if (result.flowRatePool == "移动") {
                            this.cmccAuthShow = true;
                        } else if (result.flowRatePool == "乐语") {
                            this.leyuAuthShow = true;
                        } else if (result.flowRatePool == "移动接口") {
                            this.cmccXxtx = true;
                        } else if (result.flowRatePool == '广电') {
                            this.guangdianAuth = true;
                        } else {
                            this.otherUrl = result.flowRatePool;
                            this.otherAuth = true;
                        }
                        localStorage.setItem('simInfoMap', result);
                        sessionStorage.setItem("supplierCode", result.supplierCode);
                        this.simInfo = result;
                        if (result.simPackageList.length > 1) {
                            for (let i = 0; i < result.simPackageList.length; i++) {
                                if (
                                    result.simPackageList[i].flowRatePercent &&
                                    (result.simPackageList[i].flowRatePercent / 100) *
                                    result.simPackageList[i].flowRate >
                                    result.simPackageList[i].usedFlowRate
                                ) {
                                    this.simInfo.packageName =
                                        result.simPackageList[i].packageName;
                                    this.simInfo.endTime = result.simPackageList[i].endTime;
                                    break;
                                }
                            }
                        } else if (result.simPackageList.length == 1) {
                            this.simInfo.packageName = result.simPackageList[0].packageName;
                            this.simInfo.endTime = result.simPackageList[0].endTime;
                        }
                        this.simInfo.simId = this.simInfo.simPackageList[0]
                            ? this.simInfo.simPackageList[0].simId
                            : "";
                    }
                }
            );
        },
        getAccount() {
            let param = {
                iccid: this.$store.state.iccid,
                mobile: localStorage.getItem("mobile"),
            };
            wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
                (res) => {
                    if (res.data.code == 200) {
                        this.userAccount = res.data.data;
                        this.alreadyHasAccount = true;
                        localStorage.setItem("userSimAmount", this.userAccount.amount)
                        localStorage.setItem('alreadyHasAccount', 1);
                    } else {
                        localStorage.setItem("userSimAmount", 0);
                        localStorage.setItem('alreadyHasAccount', 0);
                    }
                }
            );
        },
        toSupplierAuth() {
            if (this.isAuthName == '已实名') {
                Dialog.alert({ title: "提示", message: '已完成实名认证，无需再次实名！' });
            } else if (this.isAuthName == '请先购买套餐') {
                Dialog.confirm({
                    message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
                    confirmButtonText: "去购买",
                    cancelButtonText: "取消",
                }).then(() => {
                    this.$router.replace('/new/package');
                })
                    .catch(() => { });
            } else {
                if (this.cmccXxtx == true) {
                    wxRequest(
                        "wxAuth/cmcc/auth",
                        { iccid: this.$store.state.iccid },
                        "post"
                    ).then((res) => {
                        if (res.data.code == "200") {
                            window.location.href = res.data.data;
                        } else {
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message,
                            });
                        }
                    });
                } else if (this.ctccAuthShow == true) {
                    this.$router.push({
                        path: "/user/ctccAuth",
                        query: { realNameCard: 1 },
                    });
                } else if (this.cuccAuthShow == true) {
                    window.location.href = "http://wx.yunzhineng.top/#/user/cuccAuth";
                } else if (this.cmccAuthShow == true) {
                    this.$router.push({
                        path: "/user/cmccAuth",
                        query: { realNameCard: 1 },
                    });
                } else if (this.ctcc5GAuth == true) {
                    wxRequest(
                        "wxAuth/ctcc/to/5G/auth",
                        { iccid: this.$store.state.iccid },
                        "post"
                    ).then((res) => {
                        if (res.data.code == "200") {
                            window.location.href = res.data.data;
                        } else {
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message,
                            });
                        }
                    });
                } else if (this.ctccJieAuth == true) {
                    wxRequest(
                        "wxAuth/ctcc/to/auth",
                        { iccid: this.$store.state.iccid },
                        "post"
                    ).then((res) => {
                        if (res.data.code == "200") {
                            window.location.href = res.data.data;
                        } else {
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message,
                            });
                        }
                    });
                } else if (this.guangdianAuth == true) {
                    this.$router.push('/user/ctccGdAuth');
                }
                else {
                    window.location.href = this.otherUrl;
                }

            }
        },
        toRecharge() {
            let fd = new FormData();
            fd.append("supplierId", sessionStorage.getItem("supplierCode"));
            wxRequest("sim/invent/state", fd, "post").then((res) => {
                if (res.data.code == 200) {
                    if (this.userAccount.amount < 0) {
                        Dialog.confirm({
                            title: "提示",
                            message: "您的账户余额已透支，请先充值账户余额！",
                        })
                            .then(() => {
                                this.$router.push({
                                    path: "/new/balanceRecharge",
                                    query: {
                                        iccid: this.$store.state.iccid,
                                    },
                                });
                            })
                            .catch(() => { });
                    } else {
                        this.$router.push({
                            path: "/new/package",
                            query: {
                                iccid: this.$store.state.iccid,
                            },
                        });

                    }
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });

        },
        toBalanceRecharge() {
            if (this.yucun == 1 || this.yucun == 888) {
                this.$router.push({
                    path: "/user/huodong",
                    query: {
                        iccid: this.$store.state.iccid,
                    },
                });
            } else {
                this.$router.push({
                    path: "/new/balanceRecharge",
                    query: {
                        iccid: this.$store.state.iccid,
                    },
                });
            }


        },
    }
}
</script>
<style lang="less" scoped>
.page {
    background: linear-gradient(180deg, #537EE7 0%, #F6F9FF 20%, #F6F9FF 100%);
    padding: 18px 0;

    .top {
        background: url('~@/assets/new/53_2.png')no-repeat center;
        background-size: 100% 100%;
        width: 100%;
        height: 257px;

        .t1 {
            padding-left: 24px;
            padding-top: 34px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 22px;
        }

        .t2 {
            display: flex;
            padding-left: 24px;
            color: #FFFFFF;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            padding-top: 8px;

            .adress {
                padding-left: 15px;
            }
        }

        .v-q-y {
            padding: 34px 24px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .v-l {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #343434;
                line-height: 22px;
            }

            .v-r {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #F66B3F;
                line-height: 20px;
            }
        }

        .h-swiper {
            margin-top: 16px;
            margin-left: 24px;
            display: flex;
            align-items: center;
            margin-right: 24px;

            .swiper-i {
                /* width:27%; */
                text-align: center;
                position: relative;

                .icon {
                    height: 56px;
                    width: 56px;
                    margin: 0 auto 7px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .name {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #343434;
                    line-height: 17px;
                }

                .lock {
                    position: absolute;
                    width: 15px;
                    height: 18px;
                    right: 20px;
                    bottom: 24px;
                }
            }
        }
    }

    .v-tabs {
        display: flex;
        margin-top: 29px;
        margin-left: 32px;
        margin-right: 32px;
        align-items: center;
        justify-content: space-between;

        .tabs {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #343434;
            line-height: 20px;
        }

        .tabs-active {
            font-size: 18px;
            color: #343434;
            font-weight: 600;
            position: relative;

            &::after {
                content: '';
                width: 40px;
                height: 4px;
                background: linear-gradient(270deg, #F3F7FF 0%, #5882E7 100%);
                display: block;
                position: absolute;
                bottom: -2px;
            }
        }
    }

    .v-tabs1 {
        justify-content: center;

        .tabs {
            margin-left: 20px;

            &:nth-child(1) {
                margin-left: 0;
                margin-right: 20px;
            }
        }
    }

    .tabs-c {
        margin: 12px 12px 19px;
        background: url('~@/assets/new/49_2.png')no-repeat center;
        background-size: 100% 100%;
        height: 211px;
        position: relative;

        .tabs-top {
            display: flex;
            padding: 17px 13px;
            justify-content: space-between;
            align-items: center;

            .k-stutas {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #343434;
                line-height: 22px;

                span {
                    padding-left: 6px;
                    color: #343434;
                }
            }

            .k-stutas1 {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #343434;
                line-height: 20px;

                img {
                    width: 22px;
                    vertical-align: sub;
                    margin-right: 8px;
                }
            }

            .confirm {
                width: 79px;
                height: 30px;
                background: linear-gradient(270deg, #FA8756 0%, #F24F2B 100%);
                border-radius: 15px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                line-height: 30px;
            }
        }

        .progress {
            margin: 4px 12px 14px 12px;
        }

        .van-cell {
            height: 38px;
            border-radius: 19px;
            width: 94%;
            padding: 0 16px;
            background: rgba(25, 23, 19, 0.52);
            line-height: 38px;
            margin: auto;
            margin-bottom: 10px;
            border: 1px solid #5D5341;

            &::after {
                border: none;
            }

            ::v-deep .van-field__control {
                color: #fff;
            }
        }

        .liu {
            border-radius: 10px;
            /* background: #FFF1E5; */
            display: flex;
            align-items: center;
            /* padding: 26px 0; */
            padding-top: 6px;

            .xian {
                width: 1px;
                background: #343434;
                height: 33px;
            }

            .l {
                width: 49.5%;
                text-align: center;

                .num {
                    height: 30px;
                    font-family: HarmonyOS_Sans_SC_Bold;
                    font-size: 22px;
                    color: #343434;
                    font-weight: bold;
                    line-height: 30px;

                    span {
                        height: 17px;
                        font-family: HarmonyOS_Sans_SC;
                        font-size: 12px;
                        color: #343434;
                        font-weight: 400;
                        line-height: 17px;
                    }
                }

                .n-l {
                    height: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #908B85;
                    line-height: 20px;
                }
            }

            .c-z {
                width: 53px;
                height: 20px;
                background: #FA933B;
                border-radius: 10px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 10px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: center;
                margin: auto;
                margin-top: 3px;
            }
        }

        .btn {
            padding-top: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 20px;

            div {
                background: url('~@/assets/new/67_2.png')no-repeat center;
                height: 40px;
                width: 138px;
                background-size: 100% 100%;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 40px;

                img {
                    width: 20px;
                    height: 20px;
                    vertical-align: sub;
                    margin-right: 8px;
                }
            }
        }

        .btn2 {
            padding-top: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 10px;

            div {
                background: url('~@/assets/new/67.png')no-repeat center;
                height: 38px;
                width: 100px;
                background-size: 100% 100%;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #EFD9BC;
                text-align: center;
                line-height: 38px;

                img {
                    width: 23px;
                    height: 22px;
                    vertical-align: sub;
                }
            }

            .b-active {
                width: 100px;
                height: 38px;
                background: linear-gradient(270deg, #FC9760 0%, #F24E2A 100%);
                border-radius: 19px;
                color: #fff;
            }
        }

        .btn22 {
            justify-content: center;

            div {
                margin-left: 20px;

                &:nth-child(1) {
                    margin-left: 0;
                    margin-right: 20px;
                }
            }
        }

        .quantity {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 17px;
            margin-left: 16px;
            margin-right: 16px;

            .v-l {
                height: 52px;
                width: 46%;
                background: linear-gradient(180deg, rgba(19, 18, 15, 0) 0%, #3E2C1C 100%);
                border-radius: 16px;
                border: 1px solid rgba(50, 43, 35, 0.66);
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #EFD9BC;
                padding: 0 10px;
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;

                img {
                    width: 30px;
                    height: 21px;
                }

                &:first-child {
                    margin-right: 10px;

                    img {
                        width: 27px;
                        height: 27px;
                    }
                }
            }
        }

        .status {
            position: absolute;
            right: 0;
            border-radius: 100px 0px 0px 100px;
            height: 26px;
            width: 64px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 26px;
            text-align: center;
            font-style: normal;
            top: 48%;
        }

        .status1 {
            background: linear-gradient(270deg, #FA8D5C 0%, #F3542F 100%);
        }

        .status2 {
            background: linear-gradient(270deg, rgba(55, 54, 52, 0.74) 0%, #555046 100%);
        }
    }

    .my-swipe {
        margin: 19px 14px;
        width: calc(100% - 28px);

        .van-swipe-item {
            img {
                width: 100%;
            }
        }
    }

    .box {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #343434;
        margin: 10px 15px 13px;
        line-height: 22px;
    }

    .h5-more-fl {
        margin-top: 10px;
        /* border-radius: 10px; */
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-top: 18px;

        .fl-item {
            width: 25%;
            text-align: center;

            img {
                width: 52px;
                height: 52px;
            }

            div {
                margin-top: 8px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #343434;
                padding-bottom: 18px;
            }
        }
    }

    .footer {
        background: url('~@/assets/new/650.png')no-repeat center center;
        background-size: 100% 100%;
        padding: 12px 15px 12px 12px;
        display: flex;
        margin: 30px 13px 0;
        align-items: center;

        img {
            width: 51px;
            height: 51px;
        }

        .foot-n {
            margin-left: 60px;
            width: 60%;

            .znzd {
                height: 22px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #343434;
                line-height: 22px;
                margin-bottom: 4px;
            }

            .small {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #898E97;
                line-height: 20px;
            }
        }

        .f-btn {
            background: #4A84E8;
            border-radius: 14px;
            border: #4A84E8 1px solid;
            padding: 8px 12px;
            color: #fff;
            font-size: 14px;
            text-align: center;
        }
    }
}

.van-dialog {
    ::v-deep.van-dialog__content {
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        padding: 20px;
        border-radius: 10px;
    }

    ::v-deep .van-dialog__header {
        font-size: 20px;
        font-weight: 700;
        color: #06121e;
        text-align: center;
        margin-bottom: 10px;
    }

    .dialog-text {
        font-size: 14px;
        color: #06121e;
        margin-top: 8px;
        line-height: 28px;
    }

    .btn-vis {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 25px;

        .dialog-btn2 {
            width: 120px;
            height: 47px;
            color: #3B2C1D;
            text-align: center;
            background: rgba(52, 118, 254, 0.1) !important;
            border: 0 !important;
            border-radius: 94px;
            font-size: 16px;
            line-height: 47px;
        }

        .dialog-btn3 {
            width: 130px;
            height: 47px;
            border-radius: 94px;
            font-size: 16px;
            line-height: 47px;
            border: 0;
            color: #fff;
            background: #3B2C1D;
            text-align: center;
        }
    }
}
</style>